export default __webpack_public_path__ + "static/media/TT Norms Pro Thin.cf371514.otf";